<template>
  <!-- main -->
  <div class="container pt-10">
    <form class="py-10" @submit.prevent="doneEdit">
      <div class="row justify-content-center">
        <div class="col-md-6 pb-8 border-bottom border-dark text-dark">
          <h3 class="fs-4 fw-bold text-center">- 個人資料 -</h3>
          <div class="d-flex justify-content-center">
            <img
              src="https://fakeimg.pl/120/"
              alt="memberPhoto"
              class="rounded-pill memberPhoto-120 m-4"
            />
          </div>

          <div class="mb-13">
            <label for="trueName" class="col-form-label pb-13 pt-0"
              >真實姓名</label
            >
            <input
              type="text"
              id="trueName"
              class="
                form-control
                rounded-pill
                px-4
                py-13
                border-0
                bg-searchselect
              "
              aria-describedby="passwordHelpInline"
              placeholder="陳小明"
              v-model="UserData.Name"
            />
          </div>

          <div class="mb-13">
            <label for="memberNickname" class="col-form-label pb-13 pt-0"
              >會員暱稱</label
            >
            <input
              type="text"
              id="memberNickname"
              class="
                form-control
                rounded-pill
                px-4
                py-13
                border-0
                bg-searchselect
              "
              aria-describedby="passwordHelpInline"
              placeholder="May"
              v-model="UserData.NickName"
            />
          </div>

          <div class="mb-13">
            <label for="birthDate" class="col-form-label pb-13 pt-0"
              >出生日期</label
            >
            <input
              type="date"
              id="birthDatee"
              class="
                form-control
                rounded-pill
                px-4
                py-13
                border-0
                bg-searchselect
              "
              aria-describedby="passwordHelpInline"
              placeholder="1996 / 06 / 29"
              v-model="UserData.BirthDate"
            />
          </div>

          <div class="mb-13">
            <label for="gender" class="col-form-label pb-13 pt-0"
              >生理性別</label
            >
            <!-- 使用 radio 製作 -->
            <div id="radioSex">
              <label
                ><input
                  type="radio"
                  name="Sex"
                  v-model="UserData.Sex"
                  value="生理男"
                /><span
                  class="
                    btn btn-searchselect
                    fw-light
                    rounded-pill
                    px-4
                    py-13
                    me-4
                  "
                  >生理男</span
                ></label
              >
              <label
                ><input
                  type="radio"
                  name="Sex"
                  v-model="UserData.Sex"
                  value="生理女"
                /><span
                  class="
                    btn btn-searchselect
                    fw-light
                    rounded-pill
                    px-4
                    py-13
                    me-4
                  "
                  >生理女</span
                ></label
              >
              <label
                ><input
                  type="radio"
                  name="Sex"
                  v-model="UserData.Sex"
                  value="不公開"
                /><span
                  class="
                    btn btn-searchselect
                    fw-light
                    rounded-pill
                    px-4
                    py-13
                    me-4
                  "
                  >不公開</span
                ></label
              >
            </div>

            <!-- 原先 button 作法 -->
            <!-- <button
              type="radio"
              class="btn fw-light rounded-pill px-4 py-13 me-4"
              id="0"
              :class="[
                UserData.Sex === '生理男' ? 'btn-dark' : 'btn-searchselect'
              ]"
            >
              生理男
            </button>
            <button
              type="radio"
              class="btn fw-light rounded-pill px-4 py-13 me-4"
              id="1"
              :class="[
                UserData.Sex === '生理女' ? 'btn-dark' : 'btn-searchselect'
              ]"
            >
              生理女
            </button>
            <button
              type="radio"
              class="btn fw-light rounded-pill px-4 py-13"
              id="2"
              :class="[
                UserData.Sex === '不公開' ? 'btn-dark' : 'btn-searchselect'
              ]"
            >
              不公開
            </button> -->
          </div>

          <div class="mb-13">
            <label for="email" class="col-form-label pb-13 pt-0"
              >電子信箱</label
            >
            <input
              type="mail"
              id="email"
              class="
                form-control
                rounded-pill
                px-4
                py-13
                border-0
                bg-searchselect
              "
              aria-describedby="passwordHelpInline"
              placeholder="user@email.com"
              v-model="UserData.Account"
              disabled
            />
          </div>

          <div class="mb-13">
            <label for="cellphone" class="col-form-label pb-13 pt-0"
              >手機號碼</label
            >
            <input
              type="tel"
              id="cellphone"
              class="
                form-control
                rounded-pill
                px-4
                py-13
                border-0
                bg-searchselect
              "
              aria-describedby="passwordHelpInline"
              placeholder="0912-345-678"
              v-model="UserData.MobilePhone"
            />
          </div>

          <div class="mb-13">
            <label for="homeLocation" class="col-form-label pb-13 pt-0"
              >現居地</label
            >
            <div class="row">
              <div class="col-md-3">
                <input
                  type="text"
                  id="Country"
                  class="
                    form-control
                    rounded-pill
                    px-4
                    py-13
                    border-0
                    bg-searchselect
                  "
                  placeholder="國家"
                  v-model="UserData.Country"
                />
              </div>
              <div class="col-md-3">
                <!-- 選單模式 -->
                <!-- <select
                  class="
                    form-select
                    rounded-pill
                    px-4
                    py-13
                    border-0
                    bg-searchselect
                    text-dark
                  "
                  aria-label="Default select example"
                  v-model="UserData.Country"
                >
                  <option selected class="text-dark">高雄市</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </select> -->
                <!-- 填字模式 -->
                <input
                  type="text"
                  id="City"
                  class="
                    form-control
                    rounded-pill
                    px-4
                    py-13
                    border-0
                    bg-searchselect
                    text-dark
                  "
                  placeholder="城市"
                  v-model="UserData.City"
                />
              </div>
              <div class="col-md-6">
                <input
                  type="text"
                  id="Area"
                  class="
                    form-control
                    rounded-pill
                    px-4
                    py-13
                    border-0
                    bg-searchselect
                  "
                  placeholder="地址"
                  v-model="UserData.Area"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 我的介紹區塊 -->
      <div class="row justify-content-center">
        <div class="col-md-6 py-8 border-bottom border-dark text-dark">
          <h3 class="fs-4 fw-bold text-center">- 我的介紹 -</h3>

          <div class="mb-13">
            <div class="d-flex justify-content-between align-items-end">
              <label or="aboutMe" class="col-form-label pb-13 pt-0"
                >關於我</label
              >
              <div
                class="errorMessenger text-dark d-flex align-items-center ms-4"
                :class="{ 'd-none': aboutMeWordsOver }"
              >
                <span class="material-icons fs-6 me-1"> error </span>
                <p class="fs-7 mb-0">字數超過上限</p>
              </div>
            </div>
            <textarea
              class="form-control rounded-5 bg-searchselect border-0 px-4 py-3"
              placeholder="請輸入關於您的簡介，限制100字以內。"
              id="aboutMe"
              style="height: 100px"
              v-model="UserData.AboutMe"
              @input="checkWordsOver(this.UserData.AboutMe, 'aboutMeWordsOver')"
            ></textarea>
          </div>

          <div class="mb-13">
            <div class="d-flex justify-content-between align-items-end">
              <label for="interest" class="col-form-label pb-13 pt-0"
                >您的興趣</label
              >
              <div
                class="errorMessenger text-dark d-flex align-items-center ms-4"
                :class="{ 'd-none': interestWordsOver }"
              >
                <span class="material-icons fs-6 me-1"> error </span>
                <p class="fs-7 mb-0">字數超過上限</p>
              </div>
            </div>
            <textarea
              class="form-control rounded-5 bg-searchselect border-0 px-4 py-3"
              placeholder="請輸入關於您的簡介，限制100字以內。"
              id="interest"
              style="height: 100px"
              v-model="UserData.MyInterest"
              @input="
                checkWordsOver(this.UserData.MyInterest, 'interestWordsOver')
              "
            ></textarea>
          </div>

          <div class="mb-13">
            <div class="d-flex justify-content-between align-items-end">
              <label for="expertise" class="col-form-label pb-13 pt-0"
                >您的專長</label
              >
              <div
                class="errorMessenger text-dark d-flex align-items-center ms-4"
                :class="{ 'd-none': skillWordsOver }"
              >
                <span class="material-icons fs-6 me-1"> error </span>
                <p class="fs-7 mb-0">字數超過上限</p>
              </div>
            </div>
            <textarea
              class="form-control rounded-5 bg-searchselect border-0 px-4 py-3"
              placeholder="請輸入關於您的簡介，限制100字以內。"
              id="expertise"
              style="height: 100px"
              v-model="UserData.MySkill"
              @input="checkWordsOver(this.UserData.MySkill, 'skillWordsOver')"
            ></textarea>
          </div>
        </div>
      </div>

      <!-- 我的社群區塊 -->
      <div class="row justify-content-center">
        <div class="col-md-6 py-8">
          <h3 class="fs-4 fw-bold text-center">- 我的社群 -</h3>

          <div class="mb-13">
            <label for="facebook" class="col-form-label pb-13 pt-0"
              >Facebook</label
            >
            <input
              type="text"
              id="facebook"
              class="
                form-control
                rounded-pill
                px-4
                py-13
                border-0
                bg-searchselect
              "
              aria-describedby="passwordHelpInline"
              placeholder="https://www.facebook.com/thaktsheh"
              v-model="UserData.FacebookLink"
            />
          </div>

          <div class="mb-13">
            <label for="facebook" class="col-form-label pb-13 pt-0"
              >Instagram</label
            >
            <input
              type="text"
              id="Instagram"
              class="
                form-control
                rounded-pill
                px-4
                py-13
                border-0
                bg-searchselect
              "
              aria-describedby="passwordHelpInline"
              placeholder="https://www.instagram.com/thaktsheh"
              v-model="UserData.InstagramLink"
            />
          </div>

          <!-- 隱私設定 -->
          <div class="mb-13">
            <label for="expertise" class="col-form-label py-0 mb-3"
              >隱私設定</label
            >
            <div class="form-check mb-2">
              <input
                class="form-check-input"
                type="checkbox"
                id="comingChecked"
                v-model="UserData.ShowComingActivity"
              />
              <label class="form-check-label" for="comingChecked">
                即將到臨的活動
              </label>
            </div>
            <div class="form-check mb-2">
              <input
                class="form-check-input"
                type="checkbox"
                id="collectChecked"
                v-model="UserData.ShowCollectActivity"
              />
              <label class="form-check-label" for="collectChecked">
                已收藏的活動
              </label>
            </div>
            <div class="form-check mb-2">
              <input
                class="form-check-input"
                type="checkbox"
                id="finishChecked"
                v-model="UserData.ShowFinishActivity"
              />
              <label class="form-check-label" for="finishChecked">
                已完成的活動
              </label>
            </div>
            <div class="form-check mb-2">
              <input
                class="form-check-input"
                type="checkbox"
                id="followingChecked"
                v-model="UserData.ShowFollowing"
              />
              <label class="form-check-label" for="followingChecked">
                我追蹤的人
              </label>
            </div>
            <div class="form-check mb-2">
              <input
                class="form-check-input"
                type="checkbox"
                id="followerChecked"
                v-model="UserData.ShowFollowers"
              />
              <label class="form-check-label" for="followerChecked">
                追蹤我的人
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- 按鈕 -->
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="row">
            <div class="col-6">
              <button
                type="button"
                class="btn btn-outline-dark rounded-pill w-100 py-13"
              >
                取消編輯
              </button>
            </div>
            <div class="col-6">
              <button
                type="submit"
                class="btn btn-dark rounded-pill text-white w-100 py-13"
              >
                編輯完成
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- 完成編輯後的 Modal 元件 -->
    <edit-done-modal
      ref="EditDoneModal"
      :parentEditDoneInfo="UserData"
    ></edit-done-modal>
  </div>
</template>

<style>
#radioSex input[type='radio'] {
  display: none;
}
#radioSex input:checked + .btn {
  background: #111111;
  color: #fff;
  cursor: default;
}
#radioSex .btn {
  display: inline-block;
  margin: 0 5px 10px 0;
  padding: 5px 10px;
  background: #fcebb9;
  color: #111111;
  cursor: pointer;
}
/* #radioSex .button:hover {
  background: #bbb;
  color: #fff;
} */
</style>

<script>
import editDoneModal from '../../components/Modal/EditDoneModal.vue'
export default {
  props: ['UserId'],
  data () {
    return {
      UserData: {
        // Name: '',
        // NickName: '',
        // BirthDate: '',
        // Sex: 0,
        // MobilePhone: '',
        // Country: '',
        // City: '',
        // Area: '',
        // AboutMe: '',
        // MySkill: '',
        // MyInterest: '',
        // FacebookLink: '',
        // InstagramLink: '',
        // ShowComingActivity: true,
        // ShowCollectActivity: true,
        // ShowFinishActivity: true,
        // ShowCancelActivity: true,
        // ShowFollowing: true,
        // ShowFollowers: true
      },
      // 狀態用，檢查字數有沒有超過上限，如果超過則顯示警告提示
      aboutMeWordsOver: true,
      interestWordsOver: true,
      skillWordsOver: true
    }
  },
  components: {
    editDoneModal
  },
  created () {
    this.getUserEditData()
  },
  methods: {
    // 取得會員編輯資料
    getUserEditData () {
      const UserId = this.UserId
      console.log('個人檔案編輯', UserId)
      // 取得會員編輯資料
      // 7-17 編輯頁個人資料 (JWT)
      this.$apiHelper.get(`api/users/profile/detail/${UserId}`).then((res) => {
        console.log(res)
        if (res.data.Status) {
          // 先存 Token
          const token = res.data.JwtToken
          localStorage.setItem('JwtToken', token)

          // 將 api 資料寫入 data 資料裡(原本的)
          const getUserData = res.data.Data.userData

          const oriBirthDate = getUserData.BirthDate
          // 宣告 splitBirthDate 為生日日期分割後的值
          const splitBirthDate = this.splitBirthDate(oriBirthDate, 'T')

          // 回傳後加到 getUserData 裡的 BirthDate
          getUserData.BirthDate = splitBirthDate
          console.log(getUserData)
          // 將本地的 UserData 賦予 整理好的 getUserData
          this.UserData = getUserData
        }
      })
    },
    // 切割收到的日期字串
    splitBirthDate (date, separator) {
      if (date === null) {
        return date
      } else {
        const newBirthhDateData = date.split(separator)
        console.log(newBirthhDateData)
        // 結果出來會是一個陣列['2020-11-11', '00:00:00']
        // 宣告 newBirthDate 為結果的「年月日」
        const newBirthDate = newBirthhDateData[0]
        return newBirthDate
      }
    },
    // 因為三個輸入框方法都一樣，所以可以帶入每個欄位的內容，跟狀態的參數，來指定個別的狀態
    // 監聽字數，如果超過則出現警告提示
    checkWordsOver (typeColWords, isOverStatus) {
      if (typeColWords.length > 100) {
        // 因為傳進來的參數（isOverStatus）是字串，所以可以使用 this.XXX 的方式（字串取值方法）來讓狀態改變
        this[isOverStatus] = false
      } else {
        this[isOverStatus] = true
      }
    },
    // 完成編輯動作，送 Api
    doneEdit () {
      // 7-14 編輯個人檔案 (JWT)
      this.$apiHelper
        .put('api/users/profile/edit', this.UserData)
        .then((res) => {
          console.log(res, this.UserData)
          if (res.data.Status) {
            // 先存 Token
            const token = res.data.JwtToken
            localStorage.setItem('JwtToken', token)
            console.log(res.data.Message)
            // 如果成功編輯的話，呼叫編輯成功的 Modal 元件
            this.openEditDoneModal()
          }
        })
    },
    // 打開 EditDoneModal 元件的方法
    openEditDoneModal () {
      console.log(this.$refs.EditDoneModal)
      this.$refs.EditDoneModal.showModal()
    }
  }
}
</script>
